var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraph = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 24.01h20.993v-5.909H2.518V.01H1v24Zm19.482-1.517H2.525v-2.868h17.957v2.868Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m4 10.852 1.13 1.158 5.924-5.71 3.708 3.536L23.5 1.154 22.35.01l-7.616 7.56-3.687-3.522L4 10.852Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraph);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Graph.19c6347540bf47aff98abf9688700f45.svg";